import { MoreOptionsMenu, Portlet } from "@/components"
import { Grid, ListItem, Typography } from "@material-ui/core"
import React from "react"
import {
	Settings as SettingsIcon,
	Delete as DeleteIcon,
	ArrowForwardIos as ArrowIcon
} from "@material-ui/icons"
import useStyles from "@/pages/Admin/ClientCatalog/ClientManageFilters/ContactsFilters/components/ContactsFiltersListItem/styles"
import { BaseContactsFiltersType } from "@/protocols/ClientCatalogFilterProtocol"

type ContactFilterListItem = {
	filter: BaseContactsFiltersType
	handleUseFilters: (filter?: BaseContactsFiltersType) => void
	handleDeleteContactFilter: (id?: number, inboxChannelId?: number) => void
	handleOpenEditContactFilter: (filter?: BaseContactsFiltersType) => void
}

const ContactsFiltersListItem = (props: ContactFilterListItem) => {
	const { filter, handleUseFilters, handleOpenEditContactFilter, handleDeleteContactFilter } = props

	const classes = useStyles()

	const useFilter = () => {
		handleUseFilters(filter)
	}

	return <Grid item key={filter.id}>
		<Portlet style={{ padding: "8px 16px", minHeight: "auto" }}>
			<ListItem>
				<Grid container direction="row" justifyContent="space-between" alignItems="center">
					<Grid item xs={9}>
						<Typography
							variant="body1"
						>
							{filter.title}
						</Typography>
					</Grid>

					<Grid item xs={2}>
						<Grid container justifyContent="flex-end" spacing={2}>
							<Grid item xs={6}>
								<Grid
									container
									className={classes.iconButton}
									justifyContent="center"
									alignItems="center"
									onClick={useFilter}>
									<ArrowIcon className={classes.listItemIcon}/>
								</Grid>
							</Grid>
							<Grid item xs={6}>
								<Grid container className={classes.iconButton} justifyContent="center" alignItems="center">
									<MoreOptionsMenu
										options={[
											{
												title: "Editar",
												icon: <SettingsIcon />,
												showIcon: true,
												onClick: () => handleOpenEditContactFilter(filter)
											},
											{
												title: "Excluir",
												showIcon: true,
												color: "danger",
												icon: <DeleteIcon />,
												onClick: () => handleDeleteContactFilter(filter?.id, filter?.inboxChannelId)
											}
										]}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</ListItem>
		</Portlet>
	</Grid>
}

export default ContactsFiltersListItem
